import { render, staticRenderFns } from "./UploadImageOriDialog.vue?vue&type=template&id=3825b06e&scoped=true"
import script from "./UploadImageOriDialog.vue?vue&type=script&lang=js"
export * from "./UploadImageOriDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadImageOriDialog.vue?vue&type=style&index=0&id=3825b06e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3825b06e",
  null
  
)

export default component.exports